<section id="how-we-work" class="how-work-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Come <span>lavoriamo</span></h2>
            <p>Le nostre classifiche si basano su studi di crescita dei post e del loro ciclo di vita che ci garantiscono di capire quando un post raggiunge la massima visualizzazione.
                Da qui la nostra idea di metterli in competizione.</p>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-how-work">
                    <div class="icon">
                        <i class="fas fa-search"></i>
                    </div>
                    <h3>Ricerca</h3>
                    <p>Monitoriamo i post degli influencer di maggior successo e non.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-how-work">
                    <div class="icon">
                        <i class="fas fa-chart-area"></i>
                    </div>
                    <h3>Picco massimo</h3>
                    <p>Consideriamo almeno 48 ore di tempo affinchè il post possa raggiungere il picco massimo di visibilità.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-how-work">
                    <div class="icon">
                        <i class="far fa-paper-plane"></i>
                    </div>
                    <h3>Pubblicazione</h3>
                    <p>Pianifichiamo le nostre classifiche ogni settimana e ogni mese.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</section>
